import { createApp } from 'vue'
import App from './App.vue'

import Task from "./components/Task.vue";
import LearningModule from "./components/LearningModule.vue";
import CodeExample from "./components/CodeExample.vue";
import CodingPractise from "./components/CodingPractise.vue";
import StartingMenuModal from "./components/StartingMenuModal.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from '@fortawesome/free-regular-svg-icons';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(far);
library.add(fas);
library.add(faUserSecret)

const app = createApp(App);

app.component("font-awesome-icon", FontAwesomeIcon);
app.component("task", Task);
app.component("learning-module", LearningModule);
app.component("code-example", CodeExample);
app.component("coding-practise", CodingPractise);
app.component("starting-menu-modal", StartingMenuModal);

app.mount('#app')
